module.exports = __webpack_public_path__ + "img/BT.8b4e6266.png";